import { FunctionComponent, useState } from "react";

import { faExclamation, faPlus } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components";

import { Button } from "@/components/Button/Button";
import { ButtonColor, ButtonSize } from "@/components/Button/types";

import { classNames } from "@/utils/classNames";

import { ListPerson } from "../../../../../schema/list";
import { InfoTag } from "./InfoTag";

/**
 * On-hover affordance shown for a lead whose list has no campaign yet. Hovering swaps the
 * "No campaign created" tag for a "Create new campaign" button that opens the campaign builder
 * for the lead's list in a new tab.
 *
 * For TRACKER lists (signal-monitoring lists where reaching out is a secondary action) the
 * button is rendered in a less visually prominent, secondary style.
 */
export const CreateCampaignButton: FunctionComponent<{
	row: ListPerson;
	isTrackerList: boolean;
}> = ({ row, isTrackerList }) => {
	const [isShowing, setIsShowing] = useState<boolean>(false);

	return (
		<div
			className="group inline-flex relative z-100"
			onMouseEnter={() => setIsShowing(true)}
			onMouseLeave={() => setIsShowing(false)}
		>
			{isShowing ? (
				<Button
					className="mr-1 mb-1 min-w-[180px]"
					color={isTrackerList ? ButtonColor.ACTION_SECONDARY : ButtonColor.ACTION}
					image={
						<Icon
							className={classNames("w-3 h-3 mr-1", isTrackerList ? "text-text" : "text-white")}
							icon={faPlus}
						/>
					}
					size={ButtonSize.XS}
					title="Create new campaign"
					onClick={(e) => {
						e.stopPropagation();

						window.open(`/app/lists/create/copywriting/${row.list.id}`, "_blank");
					}}
				/>
			) : (
				<InfoTag icon={faExclamation} label={"No campaign created"} style="info" />
			)}
		</div>
	);
};
